"use client";

import { useCallback } from "react";
import { useSWRConfig } from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import {
  ICampaignSimpleMessage,
  ICampaignSimpleMessageInput,
} from "@/interfaces/campaign-simple-message.interface";
import campaignSimpleMessageService from "@/services/campaign-simple-message.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseUpdateCampaignSimpleMessageReturn =
  RequestsBaseReturn<ICampaignSimpleMessage | null> & {
    updateCampaignSimpleMessage: (
      id: number,
      data: ICampaignSimpleMessageInput
    ) => Promise<ICampaignSimpleMessage>;
  };

const useUpdateCampaignSimpleMessage = (): UseUpdateCampaignSimpleMessageReturn => {
  const { mutate } = useSWRConfig();

  const updateCampaignSimpleMessage = useCallback(
    async (id: number, data: ICampaignSimpleMessageInput): Promise<ICampaignSimpleMessage> => {
      const response = await campaignSimpleMessageService.update(id, data);
      await Promise.all([
        mutate(SWR_KEYS.getCampaignSimpleMessages),
        mutate([SWR_KEYS.getCampaignSimpleMessageById, id]),
      ]);
      return response;
    },
    [mutate]
  );

  return {
    data: null,
    isLoading: false,
    error: undefined,
    updateCampaignSimpleMessage,
  };
};

export default useUpdateCampaignSimpleMessage;
